import { observer } from 'mobx-react-lite';
import type { VFC } from 'react';
import { Switch, Route } from 'react-router-dom';

import { SiteMap } from '~/constants';
import { CategoryPage } from '~/containers/CategoryPage';
import { LandingPage } from '~/containers/LandingPage';
import { SearchResultPage } from '~/containers/SearchResultPage';

export const Routes: VFC = observer(() => (
  <Switch>
    <Route
      exact
      path={SiteMap.Home.Path}
      component={LandingPage}
    />
    <Route
      path={SiteMap.Search.Path}
      component={SearchResultPage}
    />
    <Route
      path={SiteMap.Category.Path}
      component={CategoryPage}
    />
  </Switch>
));
